import { RestaurantEmployee } from '@sales-portal/domain/accounts/screens/employee-list/types';
import { useState } from 'react';

/**
 * Owns the employee list search state and returns the subset of `employees`
 * that match the current query.
 *
 * Matching is case-insensitive and checks the employee's name and contact
 * email. Whitespace-only queries are treated as empty (no filter applied) so
 * consumers don't need to trim before calling `setSearchText`.
 *
 * @param employees - The full list of employees to filter
 * @returns `filteredEmployees` (the query-matching subset), `searchText` (the
 * current query), and `setSearchText` (updates the query — pass directly to a
 * search input's `onSearch`/`onChangeText`).
 */
export const useFilteredEmployees = (employees: RestaurantEmployee[]) => {
  const [searchText, setSearchText] = useState('');

  const query = searchText.toLowerCase().trim();
  const filteredEmployees = query
    ? employees.filter((employee) => {
        const name = employee.employee_name.toLowerCase();
        const contactEmail =
          employee.employee_contact_email?.toLowerCase() ?? '';
        return name.includes(query) || contactEmail.includes(query);
      })
    : employees;

  return { filteredEmployees, searchText, setSearchText };
};
